import type { FileLinkRelationType } from '@/types'

export const FILE_LINK_RELATION_TYPES: FileLinkRelationType[] = [
  'related',
  'references',
  'supersedes',
  'parent_of',
  'attachment_of',
]

/** Types whose row direction carries meaning (rendered with an arrow). */
export const DIRECTED_RELATION_TYPES: ReadonlySet<FileLinkRelationType> = new Set<FileLinkRelationType>([
  'references',
  'supersedes',
  'parent_of',
  'attachment_of',
])

/** Nodes fetched per graph request (initial load and each expansion). */
export const GRAPH_FETCH_LIMIT = 50

/** Hard cap on nodes kept client-side across expansions. */
export const MAX_GRAPH_NODES = 60
